// Meta Info for Timed Sprints

//--- ACT Sprints & Questions ---
// English: 30 Sprints & 450 questions
// Math:    36 sprints & 360 questions
// Reading: 24 sprints & 240 questions
// Science: 36 sprints & 240 questions
// Total:   126 sprints & 1290 questions

// English Sprints
const english = [
    { title: "Geology & Astronomy", sprints: [1, 2, 3, 4, 5] },
    { title: "History & Culture", sprints: [6, 7, 8, 9, 10] },
    { title: "Innovation & Design", sprints: [11, 12, 13, 14, 15] },
    { title: "Personal Narrative", sprints: [16, 17, 18, 19, 20] },
    { title: "Research & Technology", sprints: [21, 22, 23, 24, 25] },
    { title: "Visual & Folk Arts", sprints: [26, 27, 28, 29, 30] },
]

// Math Sprints
const math = [
    { title: "Easy Difficulty", sprints: [1, 2, 3, 4, 5, 6] },
    { title: "Easy-Medium Difficulty", sprints: [7, 8, 9, 10, 11, 12] },
    { title: "Medium Difficulty", sprints: [13, 14, 15, 16, 17, 18] },
    { title: "Medium-Hard Difficulty", sprints: [19, 20, 21, 22, 23, 24] },
    { title: "Hard Difficulty", sprints: [25, 26, 27, 28, 29, 30] },
    { title: "Extra Hard Difficulty", sprints: [31, 32, 33, 34, 35, 36] },
]

// Reading Sprints
const reading = [
    { title: "Prose Fiction Passages", sprints: [1, 2, 3, 4, 5, 6] },
    { title: "Social Science Passages", sprints: [7, 8, 9, 10, 11, 12] },
    { title: "Humanities Passages", sprints: [13, 14, 15, 16, 17, 18] },
    { title: "Natural Science Passages", sprints: [19, 20, 21, 22, 23, 24] },
]

// Science Sprints
const science = [
    { title: "Figures & Tables", sprints: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12] },
    { title: "Experiments", sprints: [13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30] },
    { title: "Debating Scientists", sprints: [31, 32, 33, 34, 35, 36] },
]

const meta = {
    subjects: {
        english,
        math,
        reading,
        science,
    },
    quantities: {
        english: 15,
        math: 10,
        reading: 10,
        science: [
            { sprint: 1, questionCount: 6 },
            { sprint: 2, questionCount: 6 },
            { sprint: 3, questionCount: 6 },
            { sprint: 4, questionCount: 6 },
            { sprint: 5, questionCount: 6 },
            { sprint: 6, questionCount: 6 },
            { sprint: 7, questionCount: 6 },
            { sprint: 8, questionCount: 6 },
            { sprint: 9, questionCount: 6 },
            { sprint: 10, questionCount: 6 },
            { sprint: 11, questionCount: 6 },
            { sprint: 12, questionCount: 6 },
            { sprint: 13, questionCount: 7 },
            { sprint: 14, questionCount: 7 },
            { sprint: 15, questionCount: 7 },
            { sprint: 16, questionCount: 7 },
            { sprint: 17, questionCount: 7 },
            { sprint: 18, questionCount: 7 },
            { sprint: 19, questionCount: 7 },
            { sprint: 20, questionCount: 7 },
            { sprint: 21, questionCount: 7 },
            { sprint: 22, questionCount: 7 },
            { sprint: 23, questionCount: 7 },
            { sprint: 24, questionCount: 7 },
            { sprint: 25, questionCount: 7 },
            { sprint: 26, questionCount: 7 },
            { sprint: 27, questionCount: 7 },
            { sprint: 28, questionCount: 7 },
            { sprint: 29, questionCount: 7 },
            { sprint: 30, questionCount: 7 },
            { sprint: 31, questionCount: 7 },
            { sprint: 32, questionCount: 7 },
            { sprint: 33, questionCount: 7 },
            { sprint: 34, questionCount: 7 },
            { sprint: 35, questionCount: 7 },
            { sprint: 36, questionCount: 7 },
        ],
    }
}

export default meta
